import appReducer from './app.reducer';
import meReducer from './me.reducer';
import authReducer from './auth.reducer';
import booksReducer from './books.reducer';
import packagesReducer from './packages.reducer';
import photosReducer from './photos.reducer';
import projectsReducer from './projects.reducer';
import usersReducer from './users.reducer';
import chaptersReducer from './chapters.reducer';
import versionsReducer from './versions.reducer';
import modalsReducer from './modals.reducer';
import tableReducer from './table.reducer';
import ratingsReducer from './ratings.reducer';
import questionnairesReducer from './questionnaires.reducer';
import sidebarReducer from './sidebar.reducer';
import interviewsReducer from './interviews.reducer';
import draftToolbarReducer from './draftToolbar.reducer';
import PricesReducer from './prices.reducer';
import ForgotPasswordReducer from './forgotPassword.reducer';
import RequestNewPasswordReducer from './requestNewPassword.reducer';
import claudeReducer from './claude.reducer';
import promptsReducer from './prompts.reducer';
import upgradeRequestsReducer from './upgradeRequests.reducer';


export default {
  app: appReducer,
  me: meReducer,
  auth: authReducer,
  books: booksReducer,
  packages: packagesReducer,
  photos: photosReducer,
  projects: projectsReducer,
  users: usersReducer,
  chapters: chaptersReducer,
  versions: versionsReducer,
  modals: modalsReducer,
  table: tableReducer,
  ratings: ratingsReducer,
  questionnaires: questionnairesReducer,
  sidebar: sidebarReducer,
  interviews: interviewsReducer,
  draftToolbar: draftToolbarReducer,
  prices: PricesReducer,
  forgotContainer: ForgotPasswordReducer,
  newPasswordContainer: RequestNewPasswordReducer,
  claude: claudeReducer,
  prompts: promptsReducer,
  upgradeRequests: upgradeRequestsReducer,
};
